import type { TableTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const tableDark: TableTheme = {
  name: 'Table',
  common: commonDark,
  self
}

export default tableDark
